import React, {useState} from "react";
import {cloneDeep} from "lodash";
import ReactChipInput from "react-chip-input";
import {arrayIncludeItem} from "@app/utils/CommonUtils";
import Select from "react-select";
import {EMPLOYER_NATIONALITIES} from "@app/constants/Nationality";
import {AREA_OPTIONS, PROVINCE_OPTIONS} from "@app/constants/Provinces";
import {BDStatusOption} from "@pages/employer/constant/Constant";

const InitSearchConditions = {
    'employer_id': '',
    'employer_name': '',
    'industry': '',
    'bd_status': '',
    'bd_note': '',
    'local_province': '',
    'local_nationality': '',
    'local_area': '',
}

const SearchEmployerInput = (props) => {
    const [searchConditions, setSearchConditions] = useState(cloneDeep(InitSearchConditions));
    const [searching, isSearching] = useState(false);

    const {searchTitle, onSearch} = props

    const onAddIndustryItem = (value, fieldName) => {
        if (!value) {
            return;
        }
        let arr = cloneDeep(searchConditions.industry)
        if (!arr) {
            arr = []
        }

        if (!arrayIncludeItem(arr, value)) {
            arr.push(value)
            searchConditions.industry = arr
            setSearchConditions({...searchConditions})
        }
    }

    const onRemoveIndustryItem = (index, fieldName) => {
        let arr = cloneDeep(searchConditions.industry)
        if (arr && arr.length > 0) {
            if (arr.length === 1) {
                arr = []
            } else {
                arr.splice(index, 1);
            }
            searchConditions.industry = arr
            setSearchConditions({...searchConditions})
        }
    }
    const onChangeSearchItem = (name, values) => {
        searchConditions[name] = values;
        setSearchConditions({...searchConditions});
    };

    const onSearchEmployers = () => {
        return onSearch(searchConditions)
    }

    const onClearSearchCondition = () => {
        setSearchConditions(cloneDeep(InitSearchConditions));
    }
    return (
        <div className="card card-default">
            <div className="card-header">
                <h3 className="card-title text-bold">{searchTitle || "Search"}</h3>
                <button type="button" className="btn btn-tool" data-card-widget="collapse">
                    <i className="fas fa-minus"/>
                </button>
                <div className="card-tools">
                    <button
                        type='button'
                        className='btn btn-default mr-3'
                        onClick={() => onClearSearchCondition()}
                    >
                        {'Clear'}
                    </button>
                    <button
                        type='button'
                        className='btn btn-primary'
                        onClick={() => onSearchEmployers()}
                        disabled={searching}
                    >
                        {searching ? 'Searching...' : 'Search'}
                    </button>
                </div>
            </div>
            <div className="card-body">
                <div className={"row"}>
                    <div className='col-sm-3'>
                        <div className='form-group'>
                            <label className={'w-100'}>Employer ID</label>
                            <input type='text' className='form-control' placeholder='Employer ID'
                                   value={searchConditions.employer_id}
                                   name={'employer_id'}
                                   onChange={event => onChangeSearchItem('employer_id', event.target.value)}/>
                        </div>
                    </div>
                    <div className='col-sm-3'>
                        <div className='form-group'>
                            <label className={'w-100'}>Tên Employer</label>
                            <input type='text' className='form-control' placeholder='Tên employer'
                                   value={searchConditions.employer_name}
                                   name={'employer_name'}
                                   onChange={event => onChangeSearchItem('employer_name', event.target.value)}/>
                        </div>
                    </div>

                    <div className='col-sm-3'>
                        <label className={'w-100'}>Industry</label>
                        <div style={{width: '100%'}}>
                            <ReactChipInput
                                classes={`class1 class2 w-100`}
                                chips={searchConditions.industry ? searchConditions.industry : []}
                                onSubmit={value => onAddIndustryItem(value)}
                                onRemove={index => onRemoveIndustryItem(index)}
                            />
                        </div>
                    </div>
                    <div className='col-sm-3'>
                        <label className={'w-100'}>BD Status</label>
                        <div style={{width: '100%'}}>
                            <Select options={BDStatusOption} isMulti
                                    value={
                                        searchConditions.bd_status ? searchConditions.bd_status : ''
                                    }
                                    onChange={values => {
                                        onChangeSearchItem('bd_status', values);
                                    }}
                            />
                        </div>
                    </div>
                    <div className='col-sm-3'>
                        <div className='form-group'>
                            <label className={'w-100'}>BD Note</label>
                            <input type='text' className='form-control' placeholder='BD note'
                                   value={searchConditions.bd_note}
                                   name={'bd_note'}
                                   onChange={event => onChangeSearchItem('bd_note', event.target.value)}/>
                        </div>
                    </div>
                    <div className='col-sm-3'>
                        <label className={'w-100'}>Quốc tịch</label>
                        <div style={{width: '100%'}}>
                            <Select options={EMPLOYER_NATIONALITIES} isMulti
                                    value={
                                        searchConditions.local_nationality ? searchConditions.local_nationality : ''
                                    }
                                    onChange={values => {
                                        onChangeSearchItem('local_nationality', values);
                                    }}
                            />
                        </div>
                    </div>
                    <div className='col-sm-3'>
                        <label className={'w-100'}>Location (Tỉnh)</label>
                        <div style={{width: '100%'}}>
                            <Select options={PROVINCE_OPTIONS} isMulti
                                    value={searchConditions.local_province}
                                    onChange={value => {
                                        onChangeSearchItem('local_province', value);
                                    }}
                            />
                        </div>
                    </div>
                    <div className='col-sm-3'>
                        <label className={'w-100'}><b>Location Miền</b></label>
                        <div style={{width: '100%'}}>
                            <Select options={AREA_OPTIONS} isMulti
                                    value={searchConditions.local_area}
                                    onChange={value => {
                                        onChangeSearchItem('local_area', value);
                                    }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SearchEmployerInput;
